(() => {
  if (window.MayLondonLocalization) return;
  window.MayLondonLocalization = true;
  const close = (details, restoreFocus = false) => {
    if (!details.open) return;
    details.open = false;
    details.querySelector('summary')?.setAttribute('aria-expanded', 'false');
    if (restoreFocus) details.querySelector('summary')?.focus();
  };
  function init(scope = document) {
    scope.querySelectorAll('[data-localization-details]').forEach((details) => {
      if (details.hasAttribute('data-localization-ready')) return;
      details.setAttribute('data-localization-ready', '');
      const summary = details.querySelector('summary');
      summary?.setAttribute('aria-expanded', String(details.open));
      details.querySelector('form')?.addEventListener('submit', (event) => {
        const form = event.currentTarget;
        let returnTo = form.querySelector('[name="return_to"]');
        if (!returnTo) { returnTo = document.createElement('input'); returnTo.type = 'hidden'; returnTo.name = 'return_to'; form.append(returnTo); }
        const root = String(window.Shopify?.routes?.root || document.documentElement.dataset.localeRoot || '/').replace(/\/$/, '');
        const path = root && (location.pathname === root || location.pathname.startsWith(root + '/')) ? location.pathname.slice(root.length) || '/' : location.pathname;
        returnTo.value = path + location.search + location.hash;
      });
      details.addEventListener('toggle', () => summary?.setAttribute('aria-expanded', String(details.open)));
      details.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && details.open) {
          event.preventDefault();
          event.stopPropagation();
          close(details, true);
        }
      });
      details.querySelector('[data-localization-close]')?.addEventListener('click', () => close(details, true));
      details.addEventListener('focusout', (event) => {
        if (event.relatedTarget && !details.contains(event.relatedTarget)) close(details);
      });
    });
  }
  document.addEventListener('click', (event) => {
    document.querySelectorAll('[data-localization-details][open]').forEach((details) => {
      if (!details.contains(event.target)) close(details);
    });
  });
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  init();
})();
